import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.find.js";
import TimeSeparator from '../TimeSeparator';
import ChartsAndBarItem from './ChartsAndBarItem';
import { InfoWindow } from 'vue2-google-maps';

import { mapState, mapMutations, mapActions } from 'vuex';
import { DateTime } from 'luxon';
var infoName = ['案場 APP 名稱', '系統啟動時間', '發電起始日期', '案場編號', '案場座向', '案場區域', '國別', '縣市', '鄉鎮區', '模組種類', '模組數量', '模組斜角', '高壓併聯', '案場廠址', '聯絡窗口', '經度', '緯度', '躉售單價(元/kWh)', '工程保固起始日', '工程保固到期日', '預設 IRR 模組', '變流器', '案場容量', '總廠容量', '模組方位', '維運負責人', '工程師工號', 'ACME 持有狀態', '電廠代號'];
var factoryInfoKeyArray = ['factoryAppName', 'systemStartupDate', 'powerStartupDate', 'projectNumber', 'caseOrientation', 'caseArea', 'country', 'county', 'district', 'moduleType', 'moduleCounts', 'moduleBevel', 'highVoltageParallel', 'caseSite', 'contactPerson', 'longitude', 'latitude', 'unitPrice', 'warrantyStartDate', 'warrantyDueDate', 'presetIrrModule', 'invModule', 'caseCapacity', 'caseCapacityInt', 'moduleOrientation', 'omPrincipal', 'omNumber', 'acmeStatus', 'powerPlantTag', 'ipCam'];
export default {
  name: 'SiteInfoDetail',
  components: {
    TimeSeparator: TimeSeparator,
    ChartsAndBarItem: ChartsAndBarItem,
    InfoWindow: InfoWindow
  },
  data: function data() {
    return {
      dateType: [{
        title: '最近30天',
        format: '',
        dateFormat: ''
      }, {
        title: '時歷史',
        format: 'yyyy-MM-dd',
        dateFormat: 'YYYY-MM-DD'
      }, {
        title: '日歷史',
        format: 'yyyy-MM',
        dateFormat: 'YYYY-MM'
      }, {
        title: '月歷史',
        format: 'yyyy',
        dateFormat: 'YYYY'
      }, {
        title: '年歷史',
        format: '',
        dateFormat: ''
      }, {
        title: '變流器歷史',
        format: 'yyyy-MM-dd',
        dateFormat: 'YYYY-MM-DD'
      }],
      dateTypeClickedIdx: 0,
      invNo: 1,
      demoCoordinate: {
        lat: 23.927734,
        lng: 121.074844
      }
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState(['factoryData', 'isNewData', 'factoryInfo', 'solarPermissionArray', 'roleOthersMenu'])), mapState('siteInfoDetail', ['voltages', 'realTimeGrid', 'weatherData', 'siteInfoDetailChartOptions', 'siteInfoValue', 'ipCamNum', 'uluru', 'demoContent', 'resError', 'resChoose', 'groupNumber'])), {}, {
    urlFid: function urlFid() {
      return this.$route.query.fid;
    },
    urlDemo: function urlDemo() {
      return this.$route.query.demo;
    },
    urlSiteName: function urlSiteName() {
      return this.$route.query.siteName;
    },
    hasQueryDemoSite: function hasQueryDemoSite() {
      return this.$route.query.siteName.includes('展示案場 ');
    },
    dateTimeFormat: function dateTimeFormat() {
      return this.dateType[this.dateTypeClickedIdx].format;
    },
    datePickerFormat: function datePickerFormat() {
      return this.dateType[this.dateTypeClickedIdx].dateFormat;
    },
    dateTypeClickedTitle: function dateTypeClickedTitle() {
      return this.dateType[this.dateTypeClickedIdx].title;
    },
    modalItems: function modalItems() {
      var _this = this;
      var tempItemArray = [];
      if (!this.siteInfoValue.length) {
        var siteInfoValueArray = Object.entries(this.siteInfoValue);
        if (this.hasQueryDemoSite) {
          siteInfoValueArray.forEach(function (x, idx) {
            var demoValue = ['(展示案場)', '2020-01-01', '-', '12345678', '東西向', '北區', '台灣', '桃園市', '桃園區', 'ABCD_0123456', '1234 Pcs', '30°', '外線高壓併，3相3線 11.4kV', '桃園市桃園區', '進金生能源服務', 121.074844, 23.927734, '8', '-', '-', '-', '11台', '一期：400Wp、二期：600kWp，共 1000kWp', 1000, '南偏東12.3°', '進金生', '000123', 'yes', '001', '-', 'Link'];
            if (x[0] === 'factoryAppName') {
              return tempItemArray.push({
                name: x[0],
                value: _this.urlSiteName
              });
            }
            if (x[0] === 'ipCam') {
              return tempItemArray.push({
                name: "IP CAM1",
                value: '-'
              });
            }
            tempItemArray.push({
              name: x[0],
              value: demoValue[idx]
            });
          });
        }
        if (!this.hasQueryDemoSite) {
          siteInfoValueArray.forEach(function (x) {
            // 無新 ipCam (ipCamNum 0 or null)
            if (x[0] === 'ipCam' && !_this.ipCamNum) {
              // 舊 / 無
              return x[1].forEach(function (imgUrl, idx) {
                tempItemArray.push({
                  name: "IP CAM".concat(idx + 1),
                  value: imgUrl
                });
              });
            }

            // 有新 ipCam，無舊有的
            if (x[0] === 'ipCam' && _this.ipCamNum && x[1].includes('-')) {
              // 直接上新的
              return _toConsumableArray(Array(_this.ipCamNum)).forEach(function (_item, idx) {
                tempItemArray.push({
                  name: "IP CAM".concat(idx + 1),
                  value: "https://accountforfactories.blob.core.windows.net/live-cam/".concat(_this.urlSiteName, "_IPCAM").concat(idx + 1, ".jpg")
                });
              });
            }

            // 有新 ipCam，有舊有的
            if (x[0] === 'ipCam' && _this.ipCamNum && !x[1].includes('-')) {
              // 新 + 舊
              var newIpCamList = _toConsumableArray(Array(_this.ipCamNum)).map(function (_item, idx) {
                return "https://accountforfactories.blob.core.windows.net/live-cam/".concat(_this.urlSiteName, "_IPCAM").concat(idx + 1, ".jpg");
              });
              return x[1].concat(newIpCamList).forEach(function (imgUrl, idx) {
                tempItemArray.push({
                  name: "IP CAM".concat(idx + 1),
                  value: imgUrl
                });
              });
            }
            tempItemArray.push({
              name: x[0],
              value: x[1] || '-'
            });
          });
        }
        tempItemArray.forEach(function (x) {
          var index = factoryInfoKeyArray.findIndex(function (y) {
            return y === x.name && y !== 'ipCam';
          });
          if (index >= 0) {
            x.name = infoName[index];
          }
        });
      }
      var tv = {
        name: '客戶網頁',
        value: 'Link'
      };
      tempItemArray.push(tv);
      if (!this.solarPermissionArray.includes('tvscreen')) {
        // role 權限
        tempItemArray = tempItemArray.filter(function (x) {
          return x.name !== '客戶網頁';
        });
      }
      return tempItemArray;
    },
    instantInfo: function instantInfo() {
      var _this2 = this;
      var list = Object.keys(this.realTimeGrid).map(function (titleKey) {
        return {
          title: _this2.$t("siteInfoDetail.".concat(titleKey)),
          value: _this2.realTimeGrid[titleKey]
        };
      });
      var filteredHasPermissionList = list.filter(function (_ref) {
        var title = _ref.title;
        return _this2.roleOthersMenu[1].list.includes(title);
      });
      return filteredHasPermissionList;
    },
    mapCenter: function mapCenter() {
      return this.urlDemo === 'true' || !this.uluru ? this.demoCoordinate : this.uluru;
    },
    infoWindowContent: function infoWindowContent() {
      return this.urlDemo === 'true' ? '展示案場' : this.urlSiteName;
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapMutations(['ADD_FACTORY_INFO'])), mapMutations('siteInfoDetail', ['referenceChartOptions', 'RESET_SITE_INFO_CHART'])), mapActions(['asyncLastSingleDoc', 'asyncInfo', 'updateSiteInfoDetailState'])), mapActions('ChartsAndBarItem', ['setSiteInfoInvSelectOptions'])), mapActions('siteInfoDetail', ['getWeather', 'getChartByHour', 'getChartByDay', 'getChartByRecentThirtyDays', 'getChartByMonth', 'getChartByYear', 'getChartByInvs'])), {}, {
    changeInfoLanguage: function changeInfoLanguage(str) {
      var index = factoryInfoKeyArray.indexOf(str);
      if (index >= 0) return infoName[index];
      return str;
    },
    valueSuffix: function valueSuffix(value, title) {
      var _title$split$;
      if (value === '-') return;
      var unit = title === null || title === void 0 ? void 0 : (_title$split$ = title.split(' (')[1]) === null || _title$split$ === void 0 ? void 0 : _title$split$.slice(0, -1);
      return unit === '°' ? '°' : ''; // 若為°則顯示在數值旁(數字右上)
    },
    unitText: function unitText(value, title) {
      var _title$split$2;
      if (value === '-') return;
      var unit = title === null || title === void 0 ? void 0 : (_title$split$2 = title.split(' (')[1]) === null || _title$split$2 === void 0 ? void 0 : _title$split$2.slice(0, -1);
      return unit === '°' ? '' : unit; // 若為°則不顯示
    },
    gotoScreen: function gotoScreen() {
      var systemTime = this.modalItems.find(function (x) {
        return x.name === '系統啟動時間';
      }).value;
      var page = this.$router.resolve({
        name: 'tvscreen',
        query: {
          siteName: this.urlSiteName,
          systemTime: systemTime,
          fid: this.urlFid,
          groupNumber: this.groupNumber,
          demo: this.urlDemo
        }
      });
      sessionStorage.setItem('allow-tvscreen', 'true'); // 用於確保是從網頁進入
      window.open(page.href, '_blank');
    },
    handleClickDateType: function handleClickDateType(idx) {
      if (this.dateTypeClickedIdx === idx) return;

      // init call api
      this.dateTypeClickedIdx = idx;
      switch (this.dateTypeClickedTitle) {
        case '最近30天':
          this.getChartByRecentThirtyDays({
            fId: this.urlFid
          });
          break;
        case '時歷史':
          this.getChartByHour({
            todayDate: DateTime.local().toFormat(this.dateTimeFormat),
            fId: this.urlFid,
            siteName: this.urlSiteName
          });
          break;
        case '日歷史':
          this.getChartByDay({
            thisMon: DateTime.local().toFormat(this.dateTimeFormat),
            fId: this.urlFid,
            siteName: this.urlSiteName
          });
          break;
        case '月歷史':
          this.getChartByMonth({
            thisYear: DateTime.local().toFormat(this.dateTimeFormat),
            fId: this.urlFid,
            siteName: this.urlSiteName
          });
          break;
        case '年歷史':
          this.getChartByYear({
            fId: this.urlFid,
            siteName: this.urlSiteName
          });
          break;
        case '變流器歷史':
          this.getChartByInvs({
            date: DateTime.local().toFormat(this.dateTimeFormat),
            invNum: this.invNo,
            fId: this.urlFid,
            siteName: this.urlSiteName
          });
      }
    },
    handleClickBarItem: function handleClickBarItem(barItemObj) {
      var chart = this.$refs.highchartsRef.chart;
      var title = barItemObj.title,
        isShow = barItemObj.isShow;
      switch (title) {
        case 'All':
          isShow ? chart.series.forEach(function (x) {
            return x.show();
          }) : chart.series.forEach(function (x) {
            return x.hide();
          });
          break;
        case 'kWh':
          var series = chart.series[0];
          isShow ? series.show() : series.hide();
          break;
        case 'IRR':
          var series1 = chart.series[1];
          isShow ? series1.show() : series1.hide();
          break;
        case 'PR':
          var series2 = chart.series[2];
          isShow ? series2.show() : series2.hide();
          break;
        case '°C':
          var series3 = chart.series[3];
          isShow ? series3.show() : series3.hide();
          break;
        case 'NTD':
          var series4 = chart.series[4];
          isShow ? series4.show() : series4.hide();
          break;
        case 'Num':
          var refObj = {
            plotOptions: {
              series: {
                dataLabels: {
                  enabled: isShow
                }
              }
            }
          };
          this.referenceChartOptions(refObj);
          break;
      }
    },
    handleSelectDate: function handleSelectDate(date) {
      switch (this.dateTypeClickedTitle) {
        case '時歷史':
          this.getChartByHour({
            todayDate: date,
            fId: this.urlFid,
            siteName: this.urlSiteName
          });
          break;
        case '日歷史':
          this.getChartByDay({
            thisMon: date,
            fId: this.urlFid,
            siteName: this.urlSiteName
          });
          break;
        case '月歷史':
          this.getChartByMonth({
            thisYear: date,
            fId: this.urlFid,
            siteName: this.urlSiteName
          });
          break;
        case '變流器歷史':
          this.getChartByInvs({
            date: date,
            invNum: this.invNo,
            fId: this.urlFid,
            siteName: this.urlSiteName
          });
          break;
      }
    },
    handleSelectInv: function handleSelectInv(invNum, date) {
      this.invNo = invNum;
      this.getChartByInvs({
        date: date,
        invNum: invNum,
        fId: this.urlFid,
        siteName: this.urlSiteName
      });
    }
  }),
  created: function created() {
    var _this3 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this3.RESET_SITE_INFO_CHART();
              if (_this3.factoryData.length) {
                _context.next = 4;
                break;
              }
              _context.next = 4;
              return _this3.asyncLastSingleDoc(_this3.urlSiteName);
            case 4:
              _this3.getChartByRecentThirtyDays({
                fId: _this3.urlFid
              });
              if (!(_this3.factoryInfo.length === 0)) {
                _context.next = 10;
                break;
              }
              _context.next = 8;
              return _this3.asyncInfo(_this3.urlSiteName);
            case 8:
              _context.next = 11;
              break;
            case 10:
              _this3.ADD_FACTORY_INFO(_this3.factoryInfo);
            case 11:
              _this3.getWeather();
              _this3.updateSiteInfoDetailState();
              _this3.setSiteInfoInvSelectOptions();
            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};